export const facilities = [
  {
    id: 'fitness-center',
    name: 'Fitness Center',
    category: 'Wellness',
    image:
      'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1540497077202-7c8a3999166f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    desc: 'State-of-the-art equipment with personal training available upon request.',
    longDesc:
      'Our Fitness Center is equipped with the latest cardiovascular and strength training machines. Whether you are looking to maintain your fitness routine or start a new one, our expert personal trainers are on hand to provide guidance and customized workout plans. The facility also includes dedicated areas for stretching and free weights.',
    keyDetails: [
      { label: 'Hours', value: '24 Hours (Keycard Access)' },
      { label: 'Personal Training', value: 'Available by appointment' },
      { label: 'Classes', value: 'Yoga, Pilates, HIIT' },
    ],
  },
  {
    id: 'indoor-pool',
    name: 'Indoor Pool',
    category: 'Wellness',
    image:
      'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1582653211939-90414b567162?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    desc: 'A 25-meter heated indoor pool, perfect for laps or relaxation.',
    longDesc:
      'The 25-meter heated indoor pool offers a serene environment for both vigorous lap swimming and leisurely dips. Surrounded by comfortable loungers and bathed in natural light from the skylights above, it is an oasis of calm. We also offer aqua aerobics classes and private swimming lessons for all ages.',
    keyDetails: [
      { label: 'Hours', value: '06:00 - 22:00 Daily' },
      { label: 'Temperature', value: '28°C (82°F)' },
      { label: 'Amenities', value: 'Towels, Swim Caps, Goggles' },
    ],
  },
  {
    id: 'the-library',
    name: 'The Library',
    category: 'Leisure',
    image:
      'https://images.unsplash.com/photo-1521587760476-6c12a4b040da?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1521587760476-6c12a4b040da?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1507842217343-583bb7270b66?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    desc: 'A quiet sanctuary featuring an extensive collection of literature and periodicals.',
    longDesc:
      'The Library is the intellectual heart of Andhra Social & Cultural Association. With oak-paneled walls, leather armchairs, and a roaring fireplace in the winter months, it provides the perfect setting for quiet contemplation or reading. Our collection includes over 10,000 volumes ranging from classic literature to contemporary non-fiction, alongside daily international newspapers and periodicals.',
    keyDetails: [
      { label: 'Hours', value: '08:00 - 23:00 Daily' },
      { label: 'Services', value: 'Book borrowing, Daily Newspapers' },
      { label: 'Atmosphere', value: 'Strictly Quiet Zone' },
    ],
  },
  {
    id: 'billiards-room',
    name: 'Billiards Room',
    category: 'Leisure',
    image:
      'https://images.unsplash.com/photo-1599839619722-39751411ea63?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1599839619722-39751411ea63?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    desc: 'Three championship-sized snooker tables in a classic setting.',
    longDesc:
      'Steeped in tradition, the Billiards Room features three meticulously maintained championship-sized snooker tables. Members can enjoy a friendly game or participate in our annual tournaments. The room is serviced by the adjacent Oak Lounge, allowing players to order refreshments while they play.',
    keyDetails: [
      { label: 'Hours', value: '11:00 - 23:30 Daily' },
      { label: 'Tables', value: '3 Championship Snooker Tables' },
      { label: 'Booking', value: 'Recommended during peak hours' },
    ],
  },
  {
    id: 'squash-courts',
    name: 'Squash Courts',
    category: 'Sports',
    image:
      'https://images.unsplash.com/photo-1628003117498-333503a4d4b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1628003117498-333503a4d4b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    desc: 'Two glass-backed squash courts available for booking.',
    longDesc:
      'Our two glass-backed squash courts are built to professional standards, offering excellent playing conditions. We host regular club nights, ladders, and tournaments for players of all levels. Professional coaching is available for those looking to improve their game.',
    keyDetails: [
      { label: 'Hours', value: '07:00 - 22:00 Daily' },
      { label: 'Courts', value: '2 Glass-backed Courts' },
      { label: 'Equipment', value: 'Rackets and balls available for hire' },
    ],
  },
  {
    id: 'cigar-lounge',
    name: 'Cigar Lounge',
    category: 'Leisure',
    image:
      'https://images.unsplash.com/photo-1527661591475-527312dd65f5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1527661591475-527312dd65f5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    desc: 'A curated selection of premium cigars in a ventilated, comfortable environment.',
    longDesc:
      'The Cigar Lounge offers a refined space for aficionados to enjoy premium cigars from around the world. Featuring state-of-the-art ventilation and plush leather seating, it is the ideal place to unwind after dinner. Our humidor is stocked with a carefully curated selection, and our staff can recommend the perfect pairing from our extensive spirits menu.',
    keyDetails: [
      { label: 'Hours', value: '17:00 - 00:00 Daily' },
      { label: 'Selection', value: 'Cuban and New World Cigars' },
      { label: 'Lockers', value: 'Private humidors available for members' },
    ],
  },
]

export const getFacilityBySlug = (slug: string) =>
  facilities.find((f) => f.id === slug)
